var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ResourceTable',_vm._g(_vm._b({attrs:{"rows":_vm.rows,"groupable":false,"schema":_vm.schema,"loading":_vm.loading,"use-query-params-for-simple-filtering":_vm.useQueryParamsForSimpleFiltering}},'ResourceTable',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }